(function () {
  function getPinnedHandles(searchParams) {
    const pin = searchParams.get('pin');
    if (!pin) return [];

    const seen = new Set();
    return pin
      .split(',')
      .map((handle) => handle.trim().toLowerCase())
      .filter((handle) => {
        if (!handle || seen.has(handle)) return false;
        seen.add(handle);
        return true;
      })
      .slice(0, 10);
  }

  function isFirstPage(searchParams) {
    const page = searchParams.get('page');
    if (!page) return true;

    return Number(page) === 1;
  }

  function getProductGrid() {
    return document.querySelector('#product-grid[data-collection-handle]');
  }

  function buildCardUrl(collectionHandle, productHandle) {
    const root = window.Shopify?.routes?.root || '/';
    const base = `${root}collections/${encodeURIComponent(collectionHandle)}/products/${encodeURIComponent(productHandle)}`;
    return `${base}?view=zasuwa-card-endpoint&section_id=zasuwa-product-card-endpoint`;
  }

  function parseProductCard(html) {
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    return parsed.querySelector('[data-product-handle]');
  }

  function escapeAttributeValue(value) {
    if (window.CSS && CSS.escape) return CSS.escape(value);
    return value.replace(/["\\]/g, '\\$&');
  }

  async function fetchProductCard(collectionHandle, productHandle) {
    const response = await fetch(buildCardUrl(collectionHandle, productHandle));
    if (!response.ok) return null;

    const html = await response.text();
    const card = parseProductCard(html);
    if (!card || card.dataset.productHandle !== productHandle) return null;

    return card;
  }

  async function applyPinnedProducts() {
    const searchParams = new URLSearchParams(window.location.search);
    if (!isFirstPage(searchParams)) return;

    const handles = getPinnedHandles(searchParams);
    if (!handles.length) return;

    const grid = getProductGrid();
    if (!grid || grid.dataset.zasuwaPinApplied === 'true') return;
    grid.dataset.zasuwaPinApplied = 'true';

    const collectionHandle = grid.dataset.collectionHandle;
    const pinnedCards = [];

    for (const handle of handles) {
      try {
        const card = await fetchProductCard(collectionHandle, handle);
        if (!card) continue;

        grid.querySelectorAll(`[data-product-handle="${escapeAttributeValue(handle)}"]`).forEach((existingCard) => {
          existingCard.remove();
        });

        pinnedCards.push(card);
      } catch (error) {
        console.warn('Pinned collection product skipped:', handle, error);
      }
    }

    for (let index = pinnedCards.length - 1; index >= 0; index -= 1) {
      grid.insertBefore(pinnedCards[index], grid.firstElementChild);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyPinnedProducts);
  } else {
    applyPinnedProducts();
  }
})();
